const poems = [

  {
    week: 1,
    title: 'Like a tree between two rivers',
    text: [
      'I practice stillness with the wind',
      '',
      'Holding my breath',
      'Dry womb wet tongue',
      'I can’t stop listening',
      'Miles away a glass hits the kitchen floor',
      'My lips are not wet.'
    ]
  },
  {
    week: 2,
    title: 'The room had two doors',
    text: [
      'Two and a half',
      'Was the age of his son',
      'When he danced a song about fire',
      'Calling upon floorboards for rhythm',
      'Until he slipped and fell on his teeth',
      'Bone beads white as milk.'
    ]
  },
  {
    week: 3,
    title: 'Talk to me',
    text: [
      'Hands resting on window sill',
      'Not for nothing',
      'Nothing for not',
      'Pretending to be calm',
      '',
      'Streets flooding pink',
      'Opened eyes, beating hearts.'
    ]
  },
  {
    week: 4,
    title: 'I will find you at the mountain’s top',
    text: [
      '',
      'I wonder',
      'From which ridge you will emerge',
      'I fear',
      'With eyes watery fixed upward',
      'I hope',
      'Blinking lashes to nothing.'
    ]
  },

  {

    week: 5,
    title: 'Not knowing what will come',
    text: [
      'Organs falling from the open mouth',
      'Nervous knuckles walking sideways',
      'Across my stomach, a line is drawn',
      'My hands can’t cover it all',
      'So I use my arms as well',
      'And wait...'
    ]
  },
  {
    week: 6,
    title: 'She has us write directives to the mirror',
    text: [
      'But I want to ask a question',
      'About the weather, my future children',
      'About what happens when I’m not there',
      'By night the room is still',
      'A few noises come from me',
      'A breath as I turn.'
    ]
  },
  {
    week: 7,
    title: 'I still don’t know what I want',
    text: [
      'Napkin wearing the scent of last night’s dinner',
      'Deep inside holding the world together',
      '',
      'The backdoor of the day tenderly closes',
      'I forgot to tell you about my day',
      'Is it too late to call?',
      '…'
    ]
  },
  {
    week: 8,
    title: 'In the other room, she practices English',
    text: [
      'You, me, she, us, and',
      'My name is',
      'Stone',
      'Three walls one window',
      'Headphones, exactly',
      'like small white vines.'
    ]
  },
  {
    week: 9,
    title: 'The invisible',
    text: [
      'Is all they talk about',
      'All they care about',
      'The shoeless man on the subway',
      'A sudden wind blows through my wet lip',
      'Underneath my tongue, I hear',
      'Get out! High fever!'
    ]
  },
  {
    week: 10,
    title: 'Little death drive',
    text: [
      'You were here',
      'I can tell from the way',
      'Your eyes turned red',
      'Pink patterns make lace of your skin',
      'If only for this reason',
      'I go on coughing so my presence is known.'
    ]
  },
  {
    week: 11,
    title: 'Renewals ',
    text: [
      'It was the second time she had lost her gloves',
      '',
      'The snow came back, again',
      'The small creases on her hands cracked',
      'She escaped to a warm place, another land',
      'For sand to leave its textured imprint',
      'On the breathing skin that rests.'
    ]
  },
  {
    week: 12,
    title: 'Hair like the weather',
    text: [
      'The evening was suddenly brighter',
      'A cloud or a thought moved',
      '',
      'Nobody noticed',
      'As salt in the air turned sweet',
      'Like a shape without fear',
      'The river running brown, her season rainy.'
    ]
  },
  {
    week: 13,
    title: 'Rules and breathing',
    text: [
      'Walking backward slowly',
      'In circles',
      'Tracing for',
      'Emptiness',
      'The child trips on a stone',
      'And panics.'
    ]
  },
  {
    week: 14,
    title: 'Departures and ',
    text: [
      'Why they always feel so',
      'Timely, like purpose for',
      'Finding your way to',
      'The place from which you can turn around',
      'Without even',
      'Noticing the changing winds.'
    ]
  },
  {
    week: 15,
    title: 'The fire is inside',
    text: [
      'Cuts a circle in the roof with its smoke',
      '',
      'Like an angry volcanic voice',
      'A hiss skyward',
      'Flowing very slowly',
      'Dusty petals in time',
      '',
      'Coming out the open mouth.'
    ]
  },
  {
    week: 16,
    title: 'A green suede couch',
    text: [
      'Stretching like a grapevine',
      'Last night’s sleep',
      '',
      'Sheets and a fingernail moon',
      '',
      'Forgetting where we are',
      'Misspelling in our sleep.'
    ]
  },
  {
    week: 17,
    title: 'Need for new',
    text: [
      'Page corner',
      'Colors',
      'Wilting',
      'Towards my',
      'Hollow spine',
      'Into my doubts.'
    ]
  },
  {
    week: 18,
    title: 'A peeking tattoo',
    text: [
      'Dot drawing',
      'Sitting body moving',
      'A cold wind on the neck',
      'Heat circling ankles',
      'Waiting to be seen',
      'A cough, its own slow lightning.'
    ]
  },
  {
    week: 19,
    title: 'Everything at the same time',
    text: [
      'The cones, the cup and the',
      'Pointy ones',
      'Being pulled into place',
      '',
      'Without reason',
      'Homeless shadow.'
    ]
  },
  {
    week: 20,
    title: 'That color I can’t see',
    text: [
      'One eye closed',
      'Trying to keep it shut',
      'I can hear your voice in the',
      'Strangest places of my',
      'Eyelids, like window shades',
      'Stuck halfway.'
    ]
  },
  {
    week: 21,
    title: 'The carpeted hallway',
    text: [
      'Seeing you around',
      'Poolside',
      'Background noise',
      'The children are laughing again',
      'We can watch them from here',
      'Cotton colors in motion.'
    ]
  },
  {
    week: 22,
    title: '3+2',
    text: [
      'Hearts got chambers',
      'That correspond to their wishes',
      'Desire like a leaking sink',
      'Louder at night',
      'Dreaming your mouth',
      'What should I do?'
    ]
  },
  {
    week: 23,
    title: 'The shoe is no longer white',
    text: [
      'Our time is plastic',
      'Shadow stripes sending',
      'Gravitational waves and mangoes',
      'Heels singing',
      '',
      'To each other.'
    ]
  },
  {
    week: 24,
    title: 'Toes forgotten in this heat',
    text: [
      'Between my fingers',
      'Rests some sunlight',
      'When I am laid into the bathtub',
      'Blue knees like small mountains',
      'Undecided about sinking.'
    ]
  },
  {
    week: 25,
    title: 'Weighing the options',
    text: [
      '',
      'And or',
      'Yes, but then',
      'Hmm',
      'Dress up sigh up',
      'Red.'
    ]
  },
  {
    week: 26,
    title: 'Yellow',
    text: [
      'Ideas from my shower curtain',
      'Porcelain circling ankles',
      'To remember',
      'A movement like heat',
      'Like that heat of yours',
      'Near the river, the lights go on blinking.'
    ]
  },
  {
    week: 27,
    title: 'Broken elongated shapes',
    text: [
      '',
      '',
      '',
      'Sidewalk geometry',
      '',
      'Slipping into the wall.'
    ]
  },
  {
    week: 28,
    title: 'Bricks breathe some space ',
    text: [
      'In a very short day',
      'The sun caught behind a building',
      'Waiting',
      'Pink and dusty',
      '',
      'And confused.'
    ]
  },
  {
    week: 29,
    title: ['Caught in the middle of a dream',
      'Your body appears to be mine  '],
    text: [
      'Maybe I’ll try to get closer',
      'Inch my fingers through the gap',
      'Between our',
      'Elbows lives',
      '',
      'A silent wish.'
    ]
  },
  {
    week: 30,
    title: 'The pillow’s cold side ',
    text: [
      '',
      'My hand as support',
      'The part beneath the bed',
      'Where nobody can reach',
      'Sunset across her floorboards.'
    ]
  },
  {
    week: 31,
    title: 'Surrounded by skin',
    text: [
      '',
      'Grape soda soft',
      'Folds and warm',
      'Bubbles turning flat',
      'On my belly.'
    ]
  },
  {
    week: 32,
    title: ['Surrounded by stones',
      'Last summer sounds'],
    text: [
      'They claimed to be',
      'Still water',
      '',
      'Flat like sky',
      'Pulling down',
      'At the edges.'
    ]
  },
  {
    week: 33,
    title: 'I want',
    text: [
      'To cover my body in',
      'Pineapple,',
      'Yellow thorns',
      '',
      'And a thick oiled skin.'
    ]
  },
  {
    week: 34,
    title: 'All the windows open',
    text: [
      '',
      'Once in a while',
      'When the lights are off',
      'Like a sudden rain',
      'Air turns us like a tongue.'
    ]
  },
  {
    week: 35,
    title: 'Sleepover',
    text: [
      'Tracing mattress valleys',
      'With my naked',
      'Will turning',
      'Into pieces of blue',
      'Automatic doors part',
      '',
      'Time.'
    ]
  },
  {
    week: 36,
    title: 'Sleeping under',
    text: [
      'A crying tree',
      'Purple apple branches',
      'Breaking into circumstances',
      '',
      'Shadowed tongue.'
    ]
  },
  {
    week: 37,
    title: 'White screen',
    text: [
      '',
      'Black text scrolling',
      'I’m feeling great',
      'Hollow space just behind',
      'Your eyes.'
    ]
  },
  {
    week: 38,
    title: 'The night made the window bright',
    text: [
      'Scratching the thickness',
      'I hum at the glass',
      'Draw an awful dog',
      'Barking song',
      '',
      'Simple goodbye.'
    ]
  },
  {
    week: 39,
    title: 'It was 8 pm again',
    text: [
      'The sound wouldn’t stop',
      'Seated oceans lapping at our',
      'Silver laughing',
      'Twisting torso on the fabric',
      'I was at a crossroads.'
    ]
  },
  {
    week: 40,
    title: 'Blurred out',
    text: [
      'Wild and falling',
      'The bottom of her foot considers',
      '',
      'Moving out of the city',
      '',
      'Dragging dried concrete.'
    ]
  },
  {
    week: 41,
    title: 'On thin ice',
    text: [
      '',
      'Hand fumbles in jean pocket',
      '',
      '',
      'Distorting time.'
    ]
  },
  {
    week: 42,
    title: 'Flatten with hot iron',
    text: [
      'Burning my tongue',
      'Her my fly on my wall',
      'And yours',
      'Brush stroke wings',
      'Just enough and more',
      'Etched beneath the table.'
    ]
  },
  {
    week: 43,
    title: 'Still, waiting',
    text: [
      '',
      'A man made of corn',
      '',
      '',
      'Sitting on the same chair.',
      '',
      '',
      '',
      '',
      'One eye open I saw',
      'Enough to tell you',
      'Skipping words stone like',
      'Platsch, platsch, platsch',
      'Sink dripping I say.'
    ]
  },
  {
    week: 44,
    title: 'Skinny dipping I mean',
    text: [
      'Tented fleece knees',
      '',
      'Purple',
      'And tending eastward',
      '',
      'Covering my face',
      'Elbows names themselves',
      '',
      'Where are you',
      'Same old same old',
      'Expanding bubble',
      '',
      'Air within her liquid walls.'
    ]
  },
  {
    week: 45,
    title: 'Just a normal one',
    text: [
      '',
      '',
      '',
      'Placing all the plates.'
    ]
  },
  {
    week: 46,
    title: ['Randomly',
      'She splat from the bike '],
    text: [
      '',
      'How can you',
      'How are you',
      'How do we even',
      'Begin to undo this thing.'
    ]
  },
  {
    week: 47,
    title: 'Therapy dogs',
    text: [
      'A tail for healing',
      'A nose for problems',
      '',
      '',
      '',
      'Left lip for knowing.'
    ]
  },
  {
    week: 48,
    title: 'G',
    text: [
      'Was written',
      'Before',
      'I had my own',
      'Way of',
      'Knowing that sound that',
      'Burns inside.'
    ]
  },
  {
    week: 49,
    title: 'Your hand its own curved letter ',
    text: [
      'Pointing to itself',
      'A half erased breath',
      'Itching on the background',
      'Three inches from a red seam',
      'That never was.'
    ]
  },
  {
    week: 50,
    title: 'Undone',
    text: [
      '',
      '',
      'Repeat',
      'Set the sun down',
      'Wait for tomorrow.'
    ]
  }
]

export default poems
